// extracted by mini-css-extract-plugin
export default {"table":"ListingsTable_table__Jp6DR","body":"ListingsTable_body__ZKlqI","head":"ListingsTable_head__Y4XK4","button":"ListingsTable_button__KOHNg"};